if (!customElements.get('anchor-links')) {
  customElements.define(
    'anchor-links',
    class AnchorLinks extends HTMLElement {
      constructor() {
        super();
        this.sections = document.querySelectorAll('.shopify-section');
        this.sectionArray = Array.from(this.sections).map((section) => section.id);
        this.anchors = this.querySelectorAll('a');
      }

      connectedCallback() {
        this.anchors.forEach((link) => {
          const selectedIndex = link.getAttribute('section-index');
          if (this.sectionArray[selectedIndex]) {
            link.href = `#${this.sectionArray[selectedIndex]}`;
            link.addEventListener('click', this.onAnchorClick.bind(this));
          }
        });
      }

      onAnchorClick(event) {
        event.preventDefault();
        const selectedTarget = event.target.closest('a');
        const selectedIndex = selectedTarget.getAttribute('section-index');
        const targetSection = document.getElementById(this.sectionArray[selectedIndex]);
        if (targetSection) {
          window.scrollTo({
            top: targetSection.offsetTop - this.getHeaderHeight(),
            behavior: 'smooth'
          });
        }
      }

      getHeaderHeight() {
        const cssVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
        const fromVar = parseFloat(cssVar);
        if (fromVar > 0) return fromVar;
        const legacy = document.querySelector('.header-group-wrapper');
        if (legacy && legacy.clientHeight > 0) return legacy.clientHeight;
        const v2 = document.querySelector('.v2mn-header');
        if (v2 && v2.clientHeight > 0) return v2.clientHeight;
        return 80;
      }
    }
  );
}
